import { Injectable, signal, effect, OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeService implements OnDestroy {
  // Signal holding the current time string (HH:mm)
  currentTime = signal<string>(this.formatTime(new Date()));

  private intervalId: number | undefined;

  constructor() {
    this.startClock();
  }

  private startClock() {
    // Update every second
    this.intervalId = window.setInterval(() => {
      this.currentTime.set(this.formatTime(new Date()));
    }, 1000);
  }

  private formatTime(date: Date): string {
    return date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  ngOnDestroy(): void {
    if (this.intervalId !== undefined) {
      clearInterval(this.intervalId);
    }
  }
}


